var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { MdToday, MdClear } from 'react-icons/md';
import formatDateFn from 'date-fns/format';
import parseDate from 'date-fns/parse';
import styled from "../../styled";
import { TextInput } from '../TextInput';
import { DatePickerInput } from './DatePickerInput';
var DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
var ISO8601_DATE_FORMAT = 'YYYY-MM-DD';
var ClearIcon = styled(MdClear)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  margin-right: ", ";\n"], ["\n  cursor: pointer;\n  margin-right: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.space.sm;
});
var OpenIcon = styled(MdToday)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
function formatDate(date, format, locale) {
    if (format === void 0) { format = DEFAULT_DATE_FORMAT; }
    if (!date) {
        return '';
    }
    return formatDateFn(date, format, (locale && { locale: locale }) || undefined);
}
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.input = React.createRef();
        _this.handleDayChange = function (day) {
            // if the typed value is empty or not valid, `day` is undefined and `modifiers` is an empty object
            var value = day ? formatDate(day, ISO8601_DATE_FORMAT) : '';
            if (value) {
                _this.props.onChange(value);
            }
        };
        _this.focus = function () {
            if (_this.input.current) {
                _this.input.current.focus();
            }
        };
        _this.clear = function () {
            _this.props.onChange('');
        };
        return _this;
    }
    DatePicker.prototype.render = function () {
        var _a = this.props, ariaDescribedBy = _a["aria-describedby"], ariaInvalid = _a["aria-invalid"], disabled = _a.disabled, disabledDates = _a.disabledDates, error = _a.error, format = _a.format, id = _a.id, isInline = _a.isInline, isInvalid = _a.isInvalid, isTouched = _a.isTouched, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, _b = _a.placeholder, placeholder = _b === void 0 ? '' : _b, value = _a.value, _c = _a.readOnly, readOnly = _c === void 0 ? false : _c, props = __rest(_a, ['aria-describedby', 'aria-invalid', "disabled", "disabledDates", "error", "format", "id", "isInline", "isInvalid", "isTouched", "name", "onBlur", "onChange", "placeholder", "value", "readOnly"]);
        var rightIcon = (React.createElement(React.Fragment, null,
            value && !disabled && React.createElement(ClearIcon, { onClick: this.clear }),
            React.createElement(OpenIcon, { onClick: this.focus, size: 18 })));
        var dayPickerProps = {
            disabledDays: disabledDates,
            showOutsideDays: true
        };
        return (React.createElement(DatePickerInput, __assign({ component: TextInput, formatDate: formatDate, placeholder: placeholder, format: format || DEFAULT_DATE_FORMAT }, props, { dayPickerProps: dayPickerProps, value: value ? parseDate(value) || '' : '', onDayChange: this.handleDayChange, inputProps: {
                'aria-describedby': ariaDescribedBy,
                'aria-invalid': ariaInvalid,
                autoComplete: 'off',
                disabled: disabled,
                error: error,
                id: id,
                isInline: isInline,
                isInvalid: isInvalid,
                isTouched: isTouched,
                name: name,
                onBlur: onBlur,
                onChange: onChange,
                ref: this.input,
                rightIcon: rightIcon,
                readOnly: readOnly
            } })));
    };
    return DatePicker;
}(React.Component));
export { DatePicker };
var templateObject_1, templateObject_2;
//# sourceMappingURL=DatePicker.js.map